export default function CallToAction() {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b921c0c8af460950020107c750b3d43d.jpg"
          alt="Ready to Book"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Ready to Book Your Skip?
        </h2>
        <p className="text-xl text-gray-200 mb-10">
          Get a free quote today and experience hassle-free waste management.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <a
            href="https://wa.me/27844606965"
            target="_blank"
            rel="noopener noreferrer"
            className="px-10 py-4 bg-orange-500 text-white text-lg font-bold rounded-full hover:bg-orange-600 transition-all hover:-translate-y-1 shadow-xl cursor-pointer whitespace-nowrap"
          >
            Get a Quote
          </a>
          <a
            href="https://wa.me/27844606965"
            target="_blank"
            rel="noopener noreferrer"
            className="px-10 py-4 bg-white border-2 border-orange-500 text-orange-500 text-lg font-bold rounded-full hover:bg-orange-500 hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            Book Now
          </a>
        </div>
      </div>

      <div className="absolute bottom-10 right-10 text-white/10 text-9xl font-bold pointer-events-none hidden lg:block">
        S2K
      </div>
    </section>
  );
}
